/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledCarousel } from "reactstrap";

const items = [
  {
    src: require("assets/img/ill/naturalGazPic.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets/img/ill/naturalGazPhoto.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets/img/ill/naturalGazTanks.jpg"),
    altText: "",
    caption: "",
    header: ""
  }
];

class Carousel extends React.Component {
  render() {
    return (
      <>
        <section className="section section-shaped">
          <div className="shape shape-style-1 shape-primary">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-md">
            <Row className="justify-content-center text-center mb-5">
              <Col lg="8">
                <h2 className="display-3 text-white font-weight-bold">Nos forces distinctives</h2>
                <p className="lead text-white opacity-8">
                  Des valeurs qui nous définissent et qui font de nous votre partenaire énergétique de choix
                </p>
              </Col>
            </Row>
            
            <Row className="justify-content-between align-items-center">
              <Col className="mb-lg-auto" lg="6">
                <div className="rounded shadow-lg overflow-hidden transform-perspective-right mb-5" style={{transform: 'perspective(1000px) rotateY(-15deg) rotateX(15deg)'}}>
                  <UncontrolledCarousel items={items} indicators={true} controls={true} />
                </div>
              </Col>
              
              <Col className="mb-5 mb-lg-0" lg="6">
                <div className="pl-4">
                  <Row>
                    <Col md="12">
                      <div className="card bg-white shadow border-0 mb-4">
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-success rounded-circle text-white mr-3">
                              <i className="ni ni-hat-3" />
                            </div>
                            <div>
                              <h5 className="card-title text-success font-weight-bold mb-1">Compétence</h5>
                              <p className="card-text text-muted mb-0">
                                Notre connaissance accrue du marché de l'approvisionnement et de la distribution au Québec.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md="12">
                      <div className="card bg-white shadow border-0 mb-4">
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-info rounded-circle text-white mr-3">
                              <i className="ni ni-favourite-28" />
                            </div>
                            <div>
                              <h5 className="card-title text-info font-weight-bold mb-1">Proximité</h5>
                              <p className="card-text text-muted mb-0">
                                Un service personnalisé tenant compte de votre niveau de gestion du risque.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md="12">
                      <div className="card bg-white shadow border-0 mb-4">
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-warning rounded-circle text-white mr-3">
                              <i className="ni ni-chart-pie-35" />
                            </div>
                            <div>
                              <h5 className="card-title text-warning font-weight-bold mb-1">Transparence</h5>
                              <p className="card-text text-muted mb-0">
                                Un prix compétitif et un accompagnement d'un professionnel de l'industrie pour une prise de décision réfléchie.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md="12">
                      <div className="card bg-gradient-primary shadow border-0">
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-white rounded-circle text-primary mr-3">
                              <i className="ni ni-trophy" />
                            </div>
                            <div>
                              <h5 className="card-title text-white font-weight-bold mb-1">Fiabilité et intégrité</h5>
                              <p className="card-text text-white opacity-8 mb-0">
                                Approvisionnement fiable avec nos partenaires de confiance (maintenant Emera Energy L.P.) et atténuation des risques.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>
      </>
    );
  }
}

export default Carousel;
